import type { SVGProps } from 'react'
const SvgSyImg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M18 5c-1.093 0-2 .907-2 2s.907 2 2 2 2-.907 2-2-.907-2-2-2" />
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M12.242 18H5.186a1.2 1.2 0 0 1-1.012-1.844L8.988 8.59a1.2 1.2 0 0 1 2.024 0l2.57 4.037 1.42-2.13a1.2 1.2 0 0 1 1.996 0l3.758 5.636A1.2 1.2 0 0 1 19.758 18h-4.944z"
			clipRule="evenodd"
		/>
	</svg>
)
export default SvgSyImg
